module.exports = __webpack_public_path__ + "media/images/flf-flower_laminated-6be9796b1f72b55600d579ad5bcff6c0.jpg";